import React from "react";
import { useSelector } from "react-redux";

// Member portal - show the member's own membership application form as the
// generated PDF (same document the admin downloads), embedded inline.
export default function MembershipFormPdf() {
  const { member } = useSelector((state) => state);
  const profile = member?.memberAuth?.profile || {};
  const member_type = localStorage.getItem("member_type");
  const kind = member_type === "Individual" ? "individual" : "other";

  const url = profile?.id
    ? `https://nsvec.com/api/public/certificate/membership-form/${kind}/${btoa(
        String(profile.id)
      )}`
    : null;

  return (
    <div className="mid-content-box">
      <div className="Title-box">
        <div className="row">
          <div className="col-md-6">
            <div className="BigTitle">Membership Form</div>
          </div>
          <div className="col-md-6 text-right">
            {url ? (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-comman"
              >
                Download / Open in new tab
              </a>
            ) : null}
          </div>
        </div>
      </div>

      {url ? (
        <div style={{ width: "100%", height: "80vh", border: "1px solid #e3e6ef" }}>
          <iframe
            title="Membership Form"
            src={url}
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </div>
      ) : (
        <p className="text-center my-5">Membership form is not available.</p>
      )}
    </div>
  );
}
